module.exports = __webpack_public_path__ + "img/ide-voice.df749362.svg";